import { AiOutlineClose } from "react-icons/ai";
import { useTheme } from "../..";

const AlignStick = ({ data }: { data: string }) => {
  const { sticky, setSticky } = useTheme();

  const handleCheckboxChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let arr = structuredClone(sticky);

    if (sticky.includes(data)) {
      arr = arr.filter((plan: any) => plan !== data);
    } else {
      arr.push(data);
    }

    setSticky(arr);
  };

  if (!data) {
    return (
      <div
        className="small-12 medium-4"
        style={{
          margin: "4px 0px",
          padding: "8px 16px",
          backgroundColor: "#F5F9FD",
          maxWidth: "300px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginRight: "10px",
          border: "1px solid #CACACA",
        }}
      ></div>
    );
  }
  return (
    <div
      className="small-12 medium-4"
      style={{
        margin: "4px 0px",
        padding: "8px 16px",
        backgroundColor: "white",
        boxShadow:
          "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
        maxWidth: "300px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginRight: "10px",
      }}
    >
      <h4
        className="secondary-color font-weight-500"
        style={{ fontSize: "18px", lineHeight: "120%" }}
      >
        {data.split("||")[0]}
      </h4>
      <button
        type="button"
        className="primary-color"
        style={{ paddingLeft: "5px", cursor: "pointer" }}
        onClick={handleCheckboxChange}
      >
        <AiOutlineClose />
      </button>
    </div>
  );
};

export default AlignStick;
